(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!window.mainBuyNowAddThenCheckoutInitialized) {
    window.mainBuyNowAddThenCheckoutInitialized = true;

    document.addEventListener('click', (event) => {
      const buyNowButton = event.target.closest('[data-buy-now-button]');

      if (!(buyNowButton instanceof HTMLButtonElement)) return;
      if (buyNowButton.disabled) return;

      const productForm = buyNowButton.closest('product-form-component');
      const addToCartButton = productForm?.querySelector('[ref="addToCartButton"]');

      if (!(productForm instanceof HTMLElement)) return;
      if (!(addToCartButton instanceof HTMLButtonElement)) return;
      if (addToCartButton.disabled) return;

      const form = addToCartButton.closest('form');
      if (!form?.checkValidity()) {
        form?.reportValidity();
        return;
      }

      productForm.dataset.redirectToCheckout = 'true';
      addToCartButton.click();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-subscription"] && !Shopify.designMode) return;
  try {
    class EmailSubscription extends HTMLElement {
    connectedCallback() {
      this.bindSubmitButton();
    }

    bindSubmitButton() {
      const form = this.querySelector('form');
      const button = this.querySelector('.email-subscription-submit .simply-button');

      if (!form || !button) {
        return;
      }

      if (button.tagName === 'BUTTON') {
        button.type = 'submit';
        return;
      }

      button.addEventListener('click', (event) => {
        event.preventDefault();
        form.requestSubmit();
      });
    }
  }

  if (!customElements.get('email-subscription')) {
    customElements.define('email-subscription', EmailSubscription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simply-buy-buttons"] && !Shopify.designMode) return;
  try {
    class ProductQuantitySelector extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      this.minusButton = this.querySelector('button[name="minus"]');
      this.plusButton = this.querySelector('button[name="plus"]');
      this.productInformation = this.closest('product-information');
      this.onClick = this.onClick.bind(this);
      this.onBeforeInput = this.onBeforeInput.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onFocus = this.onFocus.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);

      if (!(this.input instanceof HTMLInputElement)) {
        return;
      }

      this.addEventListener('click', this.onClick);
      this.input.addEventListener('beforeinput', this.onBeforeInput);
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('blur', this.onBlur);
      this.input.addEventListener('focus', this.onFocus);
      this.productInformation?.addEventListener('simply-product-information:variant-change', this.onVariantChange);
      this.applyConstraints();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.input?.removeEventListener('beforeinput', this.onBeforeInput);
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('blur', this.onBlur);
      this.input?.removeEventListener('focus', this.onFocus);
      this.productInformation?.removeEventListener('simply-product-information:variant-change', this.onVariantChange);
    }

    getConstraints() {
      const min = Number(this.dataset.min) || 1;
      const step = Number(this.dataset.step) || 1;
      const variantAvailable = this.dataset.variantAvailable !== 'false';

      return {
        min,
        step,
        available: variantAvailable,
        variantAvailable,
      };
    }

    getNormalizedValue(rawValue, { fallbackToMin = true } = {}) {
      const { min, step } = this.getConstraints();
      const sanitizedValue = String(rawValue).replace(/\D+/g, '');

      if (sanitizedValue === '') {
        return fallbackToMin ? min : null;
      }

      let value = Number(sanitizedValue);

      if (Number.isNaN(value)) {
        return fallbackToMin ? min : null;
      }

      value = Math.max(min, value);

      return min + Math.floor((value - min) / step) * step;
    }

    applyConstraints({ preserveValue = true } = {}) {
      if (!(this.input instanceof HTMLInputElement)) {
        return;
      }

      const { min, step, available } = this.getConstraints();
      const normalizedValue = preserveValue ? this.getNormalizedValue(this.input.value) : min;

      this.input.min = String(min);
      this.input.step = String(step);
      this.input.removeAttribute('max');

      this.input.disabled = !available;
      this.input.value = String(normalizedValue);
      this.updateButtonStates();
    }

    updateButtonStates() {
      if (!(this.input instanceof HTMLInputElement)) {
        return;
      }

      const { min, available } = this.getConstraints();
      const currentValue = this.getNormalizedValue(this.input.value);

      if (this.minusButton instanceof HTMLButtonElement) {
        this.minusButton.disabled = !available || currentValue <= min;
      }

      if (this.plusButton instanceof HTMLButtonElement) {
        this.plusButton.disabled = !available;
      }
    }

    updateQuantity(stepMultiplier) {
      if (!(this.input instanceof HTMLInputElement)) {
        return;
      }

      const { min, step, available } = this.getConstraints();

      if (!available) {
        return;
      }

      let nextValue = this.getNormalizedValue(this.input.value) + step * stepMultiplier;
      nextValue = Math.max(min, nextValue);

      this.input.value = String(nextValue);
      this.updateButtonStates();
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target.closest('button[name]') : null;

      if (!(target instanceof HTMLButtonElement) || !this.contains(target)) {
        return;
      }

      event.preventDefault();

      if (target.name === 'minus') {
        this.updateQuantity(-1);
        return;
      }

      if (target.name === 'plus') {
        this.updateQuantity(1);
      }
    }

    onBeforeInput(event) {
      if (event.inputType.startsWith('delete')) {
        return;
      }

      if (event.data === null) {
        return;
      }

      if (/^\d+$/.test(event.data) === false) {
        event.preventDefault();
      }
    }

    onInput() {
      if (!(this.input instanceof HTMLInputElement)) {
        return;
      }

      const sanitizedValue = this.input.value.replace(/\D+/g, '');

      if (sanitizedValue !== this.input.value) {
        this.input.value = sanitizedValue;
      }

      this.updateButtonStates();
    }

    onBlur() {
      if (!(this.input instanceof HTMLInputElement)) {
        return;
      }

      this.input.value = String(this.getNormalizedValue(this.input.value));
      this.updateButtonStates();
    }

    onFocus() {
      this.input?.select();
    }

    onVariantChange(event) {
      const variant = event.detail?.variant;

      if (!variant) {
        return;
      }

      this.dataset.min = String(variant.quantity_rule?.min || 1);
      this.dataset.step = String(variant.quantity_rule?.increment || 1);
      this.dataset.available = variant.available ? 'true' : 'false';
      this.dataset.variantAvailable = variant.available ? 'true' : 'false';
      this.dataset.cartQuantity = String(variant.cart_quantity || 0);
      this.dataset.inventoryManaged = variant.inventory_managed ? 'true' : 'false';
      this.dataset.inventoryPolicy = variant.inventory_policy || '';
      this.dataset.inventoryQuantity = String(variant.inventory_quantity || 0);

      if (variant.quantity_rule?.max) {
        this.dataset.quantityRuleMax = String(variant.quantity_rule.max);
      } else {
        delete this.dataset.quantityRuleMax;
      }

      this.applyConstraints();
    }

    setCartQuantity(cartQuantity) {
      this.dataset.cartQuantity = String(Math.max(Number(cartQuantity) || 0, 0));
      this.applyConstraints();
    }

    canAddToCart(requestedQuantity = null) {
      const { min, available } = this.getConstraints();
      const hasQuantityRuleMax = this.dataset.quantityRuleMax !== undefined && this.dataset.quantityRuleMax !== '';
      const quantityRuleMax = hasQuantityRuleMax ? Number(this.dataset.quantityRuleMax) : null;
      const inventoryManaged = this.dataset.inventoryManaged === 'true';
      const inventoryPolicy = this.dataset.inventoryPolicy || '';
      const inventoryQuantity = Number(this.dataset.inventoryQuantity || 0);
      const cartQuantity = Math.max(Number(this.dataset.cartQuantity || 0), 0);
      let max = quantityRuleMax;

      if (inventoryManaged && inventoryPolicy === 'deny') {
        const remainingInventory = Math.max(inventoryQuantity - cartQuantity, 0);

        if (max === null) {
          max = remainingInventory;
        } else {
          max = Math.min(max, remainingInventory);
        }
      }

      if (!available) {
        return {
          canAdd: false,
          maxQuantity: max !== null ? max : 0,
          reason: 'unavailable',
        };
      }

      const quantity =
        requestedQuantity === null ? this.getNormalizedValue(this.input?.value || min) : requestedQuantity;

      if (max !== null && quantity > max) {
        return {
          canAdd: false,
          maxQuantity: max,
          reason: 'quantity_limit',
        };
      }

      return {
        canAdd: true,
        maxQuantity: max,
        reason: null,
      };
    }
  }

  class AddToCartButton extends HTMLElement {
    connectedCallback() {
      this.button = this;
      this.productInformation = this.closest('product-information');
      this.quantitySelector = this.productInformation?.querySelector('product-quantity-selector') || null;
      this.errorTips = this.productInformation?.querySelector('product-error-tips') || null;
      this.variantIdInput = this.productInformation?.querySelector('[data-selected-variant-id]') || null;
      this.isLoading = false;
      this.successTimeout = null;
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);

      this.button.addEventListener('click', this.onClick);
      this.button.addEventListener('keydown', this.onKeydown);
      this.button.setAttribute('role', 'button');
      this.button.tabIndex = 0;
      this.productInformation?.addEventListener('simply-product-information:variant-change', this.onVariantChange);
      this.syncButtonState();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.button?.removeEventListener('keydown', this.onKeydown);
      this.productInformation?.removeEventListener('simply-product-information:variant-change', this.onVariantChange);

      if (this.successTimeout) {
        window.clearTimeout(this.successTimeout);
      }
    }

    getVariantId() {
      if (this.variantIdInput instanceof HTMLInputElement && this.variantIdInput.value) {
        return this.variantIdInput.value;
      }

      return this.dataset.variantId || '';
    }

    getQuantity() {
      const quantityInput = this.quantitySelector?.querySelector('input[type="number"]');

      if (!(quantityInput instanceof HTMLInputElement)) {
        return 1;
      }

      if (typeof this.quantitySelector?.getNormalizedValue === 'function') {
        const normalizedValue = this.quantitySelector.getNormalizedValue(quantityInput.value);
        quantityInput.value = String(normalizedValue);
        this.quantitySelector.updateButtonStates?.();
        return normalizedValue;
      }

      return Math.max(Number(quantityInput.value) || 1, 1);
    }

    getCartQuantityForVariant(cart, variantId) {
      if (!cart?.items || !variantId) {
        return 0;
      }

      const matchingItem = cart.items.find((item) => String(item.variant_id) === String(variantId));
      return matchingItem ? Number(matchingItem.quantity) || 0 : 0;
    }

    syncQuantitySelectorCartQuantity(cart, variantId) {
      if (!this.quantitySelector || !variantId) {
        return;
      }

      const cartQuantity = this.getCartQuantityForVariant(cart, variantId);
      this.quantitySelector.setCartQuantity?.(cartQuantity);
      this.syncButtonState();
    }

    getQuantityErrorMessage(quantityValidation) {
      if (quantityValidation?.reason === 'unavailable') {
        return this.dataset.soldOutLabel || this.dataset.unavailableLabel || this.dataset.errorLabel || '';
      }

      const template = this.dataset.quantityErrorRemainingLabel || '';
      const maxQuantity = Number(quantityValidation?.maxQuantity);

      if (!template) {
        return this.dataset.errorLabel || '';
      }

      if (!Number.isFinite(maxQuantity)) {
        return template.replace('__MAX__', '0');
      }

      return template.replace('__MAX__', String(Math.max(maxQuantity, 0)));
    }

    getSectionsToRender() {
      const sectionIds = new Set();

      document.querySelectorAll('cart-items-component').forEach((component) => {
        if (component instanceof HTMLElement && component.dataset.sectionId) {
          sectionIds.add(component.dataset.sectionId);
        }
      });

      return Array.from(sectionIds);
    }

    setButtonText(text) {
      this.textContent = text;
    }

    setButtonDisabled(isDisabled) {
      this.button.toggleAttribute('disabled', isDisabled);
      this.button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    }

    getDefaultButtonText() {
      if (this.dataset.available !== 'true') {
        return this.dataset.soldOutLabel || this.dataset.unavailableLabel || this.dataset.errorLabel || '';
      }

      return this.dataset.addToCartLabel || '';
    }

    syncButtonState() {
      const isAvailable = this.dataset.available === 'true';
      const hasVariantId = this.getVariantId() !== '';

      if (!this.isLoading) {
        this.setButtonDisabled(!isAvailable || !hasVariantId);
        this.setButtonText(this.getDefaultButtonText());
      }
    }

    setLoadingState(isLoading) {
      this.isLoading = isLoading;
      this.setButtonDisabled(isLoading || this.dataset.available !== 'true' || this.getVariantId() === '');

      if (isLoading) {
        this.setButtonText(this.dataset.addingLabel || this.dataset.errorLabel || '');
        return;
      }

      this.setButtonText(this.getDefaultButtonText());
    }

    showError(message) {
      if (!(this.errorTips instanceof HTMLElement)) {
        return;
      }

      this.errorTips.textContent = message;
      this.errorTips.dataset.visible = 'false';

      requestAnimationFrame(() => {
        if (!(this.errorTips instanceof HTMLElement) || this.errorTips.textContent !== message) {
          return;
        }

        this.errorTips.dataset.visible = 'true';
      });
    }

    clearError() {
      if (!(this.errorTips instanceof HTMLElement)) {
        return;
      }

      this.errorTips.dataset.visible = 'false';
      this.errorTips.textContent = '';
    }

    async fetchCart() {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      return response.json();
    }

    dispatchCartUpdate(cart, sections) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {
              ...cart,
              sections,
            },
            data: {
              itemCount: cart.item_count,
              sections,
              source: 'simply-product-information-add-to-cart',
            },
          },
        }),
      );
    }

    flashSuccessState() {
      if (this.successTimeout) {
        window.clearTimeout(this.successTimeout);
      }

      this.setButtonText(this.dataset.addedLabel || this.getDefaultButtonText());
      this.successTimeout = window.setTimeout(() => {
        this.successTimeout = null;
        this.syncButtonState();
      }, 1500);
    }

    async getCartErrorMessage(payload, requestedQuantity, variantId) {
      const fallbackMessage = payload.description || payload.message || this.dataset.errorLabel || '';

      if (Number(payload?.status) !== 422 || !variantId) {
        return fallbackMessage;
      }

      try {
        const cart = await this.fetchCart();
        this.syncQuantitySelectorCartQuantity(cart, variantId);
      } catch (error) {
        console.error('Failed to sync cart quantity after add error', error);
      }

      const quantityValidation = this.quantitySelector?.canAddToCart?.(requestedQuantity);

      if (quantityValidation && quantityValidation.canAdd === false) {
        return this.getQuantityErrorMessage(quantityValidation);
      }

      return fallbackMessage;
    }

    async onClick(event) {
      event.preventDefault();

      if (this.isLoading || this.button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.clearError();
      this.setLoadingState(true);

      const variantId = this.getVariantId();

      if (!variantId) {
        this.showError(this.dataset.unavailableLabel || this.dataset.errorLabel || '');
        this.setLoadingState(false);
        return;
      }

      try {
        const currentCart = await this.fetchCart();
        this.syncQuantitySelectorCartQuantity(currentCart, variantId);
      } catch (error) {
        console.error('Failed to sync cart quantity before add', error);
      }

      const quantity = this.getQuantity();
      const quantityValidation = this.quantitySelector?.canAddToCart?.(quantity);

      if (quantityValidation && quantityValidation.canAdd === false) {
        this.showError(this.getQuantityErrorMessage(quantityValidation));
        this.setLoadingState(false);
        return;
      }

      const sections = this.getSectionsToRender();
      const formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', String(quantity));

      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        });
        const payload = await response.json();

        if (!response.ok || payload.status) {
          const errorMessage = await this.getCartErrorMessage(payload, quantity, variantId);
          this.showError(errorMessage);
          return;
        }

        const cart = await this.fetchCart();
        this.syncQuantitySelectorCartQuantity(cart, variantId);
        this.setLoadingState(false);
        this.dispatchCartUpdate(cart, payload.sections || {});
        window.__cartDrawerShell?.open?.();
        this.flashSuccessState();
      } catch (error) {
        console.error('Failed to add item to cart', error);
        this.showError(this.dataset.errorLabel || '');
      } finally {
        if (this.isLoading) {
          this.setLoadingState(false);
        }
      }
    }

    onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.button.click();
    }

    onVariantChange(event) {
      const variant = event.detail?.variant;

      if (!variant) {
        return;
      }

      this.dataset.variantId = String(variant.id || '');
      this.dataset.available = variant.available ? 'true' : 'false';
      this.syncButtonState();
      this.clearError();
    }
  }

  if (!customElements.get('product-quantity-selector')) {
    customElements.define('product-quantity-selector', ProductQuantitySelector);
  }

  if (!customElements.get('add-to-cart-button')) {
    customElements.define('add-to-cart-button', AddToCartButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simply-comparison"] && !Shopify.designMode) return;
  try {
    class SimplyComparison extends HTMLElement {
    connectedCallback() {
      this.afterLayer = this.querySelector('.simply-comparison-after');
      this.handle = this.querySelector('.simply-comparison-handle');
      this.hasAnimated = false;
      this.hasInteracted = false;
      this.initialPosition = Number(this.dataset.initialPosition || 70);
      this.entrancePosition = Number(this.dataset.entrancePosition || 50);
      this.isDragging = false;

      if (!this.handle) {
        return;
      }

      this.updatePosition(this.initialPosition);
      this.handle.addEventListener('pointerdown', this.handlePointerDown);
      window.addEventListener('pointermove', this.handlePointerMove);
      window.addEventListener('pointerup', this.handlePointerUp);
      window.addEventListener('pointercancel', this.handlePointerUp);
      this.setupEntranceAnimation();
    }

    disconnectedCallback() {
      if (this.handle) {
        this.handle.removeEventListener('pointerdown', this.handlePointerDown);
      }

      window.removeEventListener('pointermove', this.handlePointerMove);
      window.removeEventListener('pointerup', this.handlePointerUp);
      window.removeEventListener('pointercancel', this.handlePointerUp);

      if (this.afterLayer) {
        this.afterLayer.removeEventListener('transitionend', this.handleEntranceTransitionEnd);
      }

      if (this.visibilityObserver) {
        this.visibilityObserver.disconnect();
      }
    }

    handlePointerDown = (event) => {
      this.isDragging = true;
      this.hasInteracted = true;
      this.removeEntranceAnimation();
      this.handle.setPointerCapture(event.pointerId);
      this.updateValueFromPointer(event);
    };

    handlePointerMove = (event) => {
      if (!this.isDragging) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      this.updateValueFromPointer(event);
    };

    handlePointerUp = (event) => {
      if (!this.isDragging) {
        return;
      }

      this.isDragging = false;

      if (this.handle && this.handle.hasPointerCapture(event.pointerId)) {
        this.handle.releasePointerCapture(event.pointerId);
      }
    };

    handleEntranceTransitionEnd = (event) => {
      if (event.propertyName != 'clip-path') {
        return;
      }

      this.removeEntranceAnimation();
    };

    setupEntranceAnimation() {
      if (!('IntersectionObserver' in window)) {
        this.playEntranceAnimation();
        return;
      }

      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            this.playEntranceAnimation();
          });
        },
        {
          threshold: 0.35,
        }
      );

      this.visibilityObserver.observe(this);
    }

    playEntranceAnimation() {
      if (this.hasAnimated || this.hasInteracted) {
        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
        }
        return;
      }

      this.hasAnimated = true;
      this.setAttribute('data-animate-position', '');
      if (this.afterLayer) {
        this.afterLayer.addEventListener('transitionend', this.handleEntranceTransitionEnd, { once: true });
      }
      requestAnimationFrame(() => this.updatePosition(this.entrancePosition));

      if (this.visibilityObserver) {
        this.visibilityObserver.disconnect();
      }
    }

    removeEntranceAnimation() {
      this.removeAttribute('data-animate-position');
    }

    updateValueFromPointer(event) {
      const rect = this.getBoundingClientRect();
      const relativePosition = ((event.clientX - rect.left) / rect.width) * 100;
      const nextPosition = Math.min(100, Math.max(0, relativePosition));

      this.updatePosition(nextPosition);
    }

    updatePosition(value) {
      this.style.setProperty('--comparison-position', value + '%');
    }
  }

  if (!customElements.get('simply-comparison')) {
    customElements.define('simply-comparison', SimplyComparison);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simply-product-media"] && !Shopify.designMode) return;
  try {
    class ProductMediaSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-media-slideshow__track');
      this.slides = Array.from(this.querySelectorAll('.product-media-slideshow__slide'));
      this.currentIndex = 0;
      this.isDragging = false;
      this.dragOffset = 0;
      this.startX = 0;
      this.pointerId = null;
      this.dragDistance = 0;
      this.suppressClick = false;
      this.slideSpan = 0;
      this.pendingTranslate = 0;
      this.rafId = null;
      this.resetTransitionFrame = null;
      this.heightFrame = null;
      this.currentSlideHeight = 0;
      this.resizeObserver = null;
      this.transitionMode = this.dataset.transition || 'slide';
      this.videoElements = Array.from(this.querySelectorAll('video'));
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onVideoMetadata = this.onVideoMetadata.bind(this);

      if (!this.track) {
        return;
      }

      this.updateMeasurements();
      this.renderPosition();
      this.updateActiveSlideHeight();
      this.emitSlideChange();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.clientWidth === 0) {
            return;
          }

          this.refreshLayout();
        });
        this.resizeObserver.observe(this);
      }

      this.videoElements.forEach((video) => {
        video.addEventListener('loadedmetadata', this.onVideoMetadata);
      });

      if (this.slides.length <= 1) {
        return;
      }

      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointermove', this.onPointerMove);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerUp);
      this.addEventListener('dragstart', this.onDragStart);
      this.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.removeEventListener('pointermove', this.onPointerMove);
      this.removeEventListener('pointerup', this.onPointerUp);
      this.removeEventListener('pointercancel', this.onPointerUp);
      this.removeEventListener('dragstart', this.onDragStart);
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.onResize);
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
      if (this.resetTransitionFrame) {
        cancelAnimationFrame(this.resetTransitionFrame);
      }
      if (this.heightFrame) {
        cancelAnimationFrame(this.heightFrame);
      }
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.videoElements.forEach((video) => {
        video.removeEventListener('loadedmetadata', this.onVideoMetadata);
      });
    }

    onPointerDown(event) {
      if (event.pointerType == 'mouse' && event.button !== 0) {
        return;
      }

      const interactiveTarget =
        event.target instanceof Element ? event.target.closest('button, a, input, select, textarea, summary') : null;
      if (interactiveTarget instanceof HTMLElement) {
        return;
      }

      const videoTarget = event.target instanceof Element ? event.target.closest('video') : null;
      if (videoTarget instanceof HTMLVideoElement && this.isVideoControlInteraction(event, videoTarget)) {
        return;
      }

      if (!this.track || !this.slides.length) {
        return;
      }

      this.isDragging = true;
      this.dragOffset = 0;
      this.dragDistance = 0;
      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.classList.add('is-dragging');
      this.track.style.transition = 'none';
      event.preventDefault();
      this.setPointerCapture(event.pointerId);
    }

    isVideoControlInteraction(event, video) {
      const videoBounds = video.getBoundingClientRect();
      const controlsHeight = Math.min(64, videoBounds.height * 0.3);

      return event.clientY >= videoBounds.bottom - controlsHeight;
    }

    onPointerMove(event) {
      if (!this.isDragging) {
        return;
      }

      if (event.pointerId !== this.pointerId) {
        return;
      }

      const maxOffset = this.currentIndex * this.slideSpan;
      const minOffset = -((this.slides.length - 1 - this.currentIndex) * this.slideSpan);
      const nextOffset = event.clientX - this.startX;

      event.preventDefault();
      this.dragDistance = Math.max(this.dragDistance, Math.abs(nextOffset));
      this.dragOffset = Math.min(Math.max(nextOffset, minOffset), maxOffset);
      this.requestRender();
    }

    onPointerUp(event) {
      if (!this.isDragging) {
        return;
      }

      if (event.pointerId !== this.pointerId) {
        return;
      }

      if (this.hasPointerCapture(event.pointerId)) {
        this.releasePointerCapture(event.pointerId);
      }

      const threshold = this.clientWidth * 0.12;
      let nextIndex = this.currentIndex;

      if (this.dragOffset < -threshold && this.currentIndex < this.slides.length - 1) {
        nextIndex += 1;
      } else if (this.dragOffset > threshold && this.currentIndex > 0) {
        nextIndex -= 1;
      }

      this.isDragging = false;
      this.pointerId = null;
      this.dragOffset = 0;
      this.classList.remove('is-dragging');
      this.track.style.transition = '';
      this.suppressClick = this.dragDistance > 6;
      if (this.suppressClick) {
        requestAnimationFrame(() => {
          this.suppressClick = false;
        });
      }
      this.select(nextIndex);
    }

    onResize() {
      if (!this.track) {
        return;
      }

      this.refreshLayout();
    }

    onVideoMetadata() {
      this.updateActiveSlideHeight();
    }

    onDragStart(event) {
      event.preventDefault();
    }

    onClick(event) {
      if (this.suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('.prev-btn, .next-btn')) {
        return;
      }

      if (target?.closest('video')) {
        return;
      }

      const galleryContainer = this.closest('product-gallery-container');
      const mobileZoomEnabled = galleryContainer?.dataset.enableMobileZoom === 'true';

      if (window.matchMedia('(max-width: 767px)').matches && !mobileZoomEnabled) {
        return;
      }

      const fullScreenSlideshowId = galleryContainer?.dataset.fullScreenSlideshowId;
      const fullScreenSlideshow = fullScreenSlideshowId ? document.getElementById(fullScreenSlideshowId) : null;

      fullScreenSlideshow?.open(this.currentIndex);
    }

    updateMeasurements() {
      if (!this.slides.length) {
        this.slideSpan = this.clientWidth;
        return;
      }

      const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      const slideWidth = parseFloat(window.getComputedStyle(this.slides[0]).width);

      if (Number.isNaN(slideWidth)) {
        this.slideSpan = this.slides[0].getBoundingClientRect().width + gap;
        return;
      }

      this.slideSpan = slideWidth + gap;
    }

    requestRender() {
      if (this.rafId) {
        return;
      }

      this.rafId = requestAnimationFrame(() => {
        this.renderPosition();
        this.rafId = null;
      });
    }

    renderPosition() {
      if (!this.track) {
        return;
      }

      if (this.transitionMode === 'fade') {
        this.track.style.transform = '';
        this.slides.forEach((slide, index) => {
          const isActive = index === this.currentIndex;
          slide.setAttribute('data-active', isActive ? 'true' : 'false');
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.toggleAttribute('inert', !isActive);
        });
        return;
      }

      this.pendingTranslate = -this.currentIndex * this.slideSpan + this.dragOffset;
      this.track.style.transform = `translate3d(${this.pendingTranslate}px, 0, 0)`;
    }

    refreshLayout() {
      if (!this.track) {
        return;
      }

      this.updateMeasurements();
      this.track.style.transition = 'none';
      this.renderPosition();
      this.updateActiveSlideHeight();
      if (this.resetTransitionFrame) {
        cancelAnimationFrame(this.resetTransitionFrame);
      }
      this.resetTransitionFrame = requestAnimationFrame(() => {
        this.track.style.transition = '';
        this.resetTransitionFrame = null;
      });
    }

    select(index) {
      const nextIndex = this.clampIndex(index);
      const hasChanged = nextIndex !== this.currentIndex;
      const previousSlide = this.slides[this.currentIndex];

      this.currentIndex = nextIndex;
      this.dragOffset = 0;
      this.requestRender();
      this.updateActiveSlideHeight();

      if (hasChanged) {
        const previousVideo = previousSlide?.querySelector('video');
        previousVideo?.pause();
        this.emitSlideChange();
      }
    }

    previous() {
      this.select(this.currentIndex - 1);
    }

    next() {
      this.select(this.currentIndex + 1);
    }

    clampIndex(index) {
      if (!this.slides.length) {
        return 0;
      }

      return Math.min(Math.max(index, 0), this.slides.length - 1);
    }

    updateActiveSlideHeight() {
      if (this.heightFrame) {
        return;
      }

      this.heightFrame = requestAnimationFrame(() => {
        this.heightFrame = null;
        const activeSlide = this.slides[this.currentIndex];
        if (!activeSlide) {
          return;
        }

        const slideHeight = Math.ceil(activeSlide.getBoundingClientRect().height);
        if (slideHeight > 0 && slideHeight !== this.currentSlideHeight) {
          this.currentSlideHeight = slideHeight;
          this.style.height = `${slideHeight}px`;
        }
      });
    }

    emitSlideChange() {
      this.dispatchEvent(
        new CustomEvent('product-media-slideshow:change', {
          bubbles: true,
          detail: {
            currentIndex: this.currentIndex,
            slideCount: this.slides.length,
          },
        }),
      );
    }
  }

  class ProductMediaControls extends HTMLElement {
    connectedCallback() {
      this.mediaSlideshow = this.closest('product-gallery-container')?.querySelector('[data-product-media-slideshow]');
      this.prevButton = this.querySelector('.prev-btn');
      this.nextButton = this.querySelector('.next-btn');
      this.onClick = this.onClick.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      if (!this.mediaSlideshow) {
        return;
      }

      this.addEventListener('click', this.onClick);
      this.mediaSlideshow.addEventListener('product-media-slideshow:change', this.onMediaChange);
      this.updateControls(this.mediaSlideshow.currentIndex || 0, this.mediaSlideshow.slides?.length || 0);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.mediaSlideshow?.removeEventListener('product-media-slideshow:change', this.onMediaChange);
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target : null;

      if (!target) {
        return;
      }

      const previousButton = target.closest('.prev-btn');
      if (previousButton instanceof HTMLElement) {
        this.mediaSlideshow?.previous();
        return;
      }

      const nextButton = target.closest('.next-btn');
      if (nextButton instanceof HTMLElement) {
        this.mediaSlideshow?.next();
        return;
      }
    }

    onMediaChange(event) {
      this.updateControls(event.detail.currentIndex, event.detail.slideCount);
    }

    updateControls(currentIndex, slideCount) {
      const hasMultipleSlides = slideCount > 1;

      if (this.prevButton instanceof HTMLButtonElement) {
        this.prevButton.hidden = !hasMultipleSlides;
        this.prevButton.disabled = currentIndex === 0;
      }

      if (this.nextButton instanceof HTMLButtonElement) {
        this.nextButton.hidden = !hasMultipleSlides;
        this.nextButton.disabled = !hasMultipleSlides || currentIndex === slideCount - 1;
      }
    }
  }

  class MediaDots extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-media-dot-index]'));
      this.scroller = this.querySelector('[data-media-dots-scroller]');
      this.previousButton = this.querySelector('[data-media-dots-previous]');
      this.nextButton = this.querySelector('[data-media-dots-next]');
      this.mediaSlideshow = this.closest('product-gallery-container')?.querySelector('[data-product-media-slideshow]');
      this.currentIndex = 0;
      this.pointerId = null;
      this.pointerStartX = 0;
      this.pointerStartScrollLeft = 0;
      this.dragDistance = 0;
      this.pressedButton = null;
      this.suppressClick = false;
      this.resizeObserver = null;
      this.mobileMediaQuery = window.matchMedia('(max-width: 767px)');
      this.onClick = this.onClick.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.updateChevronState = this.updateChevronState.bind(this);

      if (!this.buttons.length || !(this.scroller instanceof HTMLElement)) {
        return;
      }

      this.addEventListener('click', this.onClick);
      this.scroller.addEventListener('pointerdown', this.onPointerDown);
      this.scroller.addEventListener('pointermove', this.onPointerMove);
      this.scroller.addEventListener('pointerup', this.onPointerUp);
      this.scroller.addEventListener('pointercancel', this.onPointerUp);
      this.scroller.addEventListener('scroll', this.updateChevronState, { passive: true });
      this.mediaSlideshow?.addEventListener('product-media-slideshow:change', this.onMediaChange);
      this.updateActiveThumbnail(this.mediaSlideshow?.currentIndex || 0, false);
      this.updateChevronState();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateChevronState);
        this.resizeObserver.observe(this.scroller);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.scroller?.removeEventListener('pointerdown', this.onPointerDown);
      this.scroller?.removeEventListener('pointermove', this.onPointerMove);
      this.scroller?.removeEventListener('pointerup', this.onPointerUp);
      this.scroller?.removeEventListener('pointercancel', this.onPointerUp);
      this.scroller?.removeEventListener('scroll', this.updateChevronState);
      this.mediaSlideshow?.removeEventListener('product-media-slideshow:change', this.onMediaChange);
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
    }

    onClick(event) {
      if (this.suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      const previousButton =
        event.target instanceof Element ? event.target.closest('[data-media-dots-previous]') : null;
      if (previousButton instanceof HTMLButtonElement) {
        this.scrollDots(-1);
        return;
      }

      const nextButton = event.target instanceof Element ? event.target.closest('[data-media-dots-next]') : null;
      if (nextButton instanceof HTMLButtonElement) {
        this.scrollDots(1);
        return;
      }

      const button = event.target instanceof Element ? event.target.closest('[data-media-dot-index]') : null;

      if (!(button instanceof HTMLElement)) {
        return;
      }

      const index = Number(button.dataset.mediaDotIndex);

      if (Number.isNaN(index)) {
        return;
      }

      this.mediaSlideshow?.select(index);
    }

    onMediaChange(event) {
      this.updateActiveThumbnail(event.detail.currentIndex);
    }

    onPointerDown(event) {
      if (this.mobileMediaQuery.matches) {
        return;
      }

      if (event.pointerType == 'mouse' && event.button !== 0) {
        return;
      }

      if (this.scroller.scrollWidth <= this.scroller.clientWidth) {
        return;
      }

      this.pressedButton = event.target instanceof Element ? event.target.closest('[data-media-dot-index]') : null;
      this.pointerId = event.pointerId;
      this.pointerStartX = event.clientX;
      this.pointerStartScrollLeft = this.scroller.scrollLeft;
      this.dragDistance = 0;
      this.scroller.classList.add('cursor-grabbing');
      this.scroller.setPointerCapture(event.pointerId);
      event.preventDefault();
    }

    onPointerMove(event) {
      if (event.pointerId !== this.pointerId) {
        return;
      }

      const deltaX = event.clientX - this.pointerStartX;

      this.dragDistance = Math.max(this.dragDistance, Math.abs(deltaX));
      this.scroller.scrollLeft = this.pointerStartScrollLeft - deltaX;
      event.preventDefault();
    }

    onPointerUp(event) {
      if (event.pointerId !== this.pointerId) {
        return;
      }

      if (this.scroller.hasPointerCapture(event.pointerId)) {
        this.scroller.releasePointerCapture(event.pointerId);
      }

      this.pointerId = null;
      this.scroller.classList.remove('cursor-grabbing');

      if (this.dragDistance > 6) {
        this.suppressClick = true;
        requestAnimationFrame(() => {
          this.suppressClick = false;
        });
      } else if (this.pressedButton instanceof HTMLElement) {
        const index = Number(this.pressedButton.dataset.mediaDotIndex);

        if (Number.isNaN(index) === false) {
          this.mediaSlideshow?.select(index);
        }
      }

      this.pressedButton = null;
    }

    scrollDots(direction) {
      if (!this.mobileMediaQuery.matches || !(this.scroller instanceof HTMLElement)) {
        return;
      }

      const currentScroll = this.scroller.scrollLeft;
      const maximumScroll = Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);
      const scrollerLeft = this.scroller.getBoundingClientRect().left;
      const positions = this.buttons.map(
        (button) => currentScroll + button.getBoundingClientRect().left - scrollerLeft,
      );
      const firstPosition = positions[0] || 0;
      const normalizedPositions = positions.map((position) => position - firstPosition);
      let targetScroll = direction > 0 ? maximumScroll : 0;

      if (direction > 0) {
        const nextPosition = normalizedPositions.find((position) => position > currentScroll + 1);
        if (typeof nextPosition === 'number') {
          targetScroll = nextPosition;
        }
      } else {
        const previousPositions = normalizedPositions.filter((position) => position < currentScroll - 1);
        const previousPosition = previousPositions.at(-1);
        if (typeof previousPosition === 'number') {
          targetScroll = previousPosition;
        }
      }

      this.scroller.scrollTo({
        left: Math.min(Math.max(targetScroll, 0), maximumScroll),
        behavior: 'smooth',
      });
    }

    updateChevronState() {
      if (!(this.scroller instanceof HTMLElement)) {
        return;
      }

      const maximumScroll = Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);

      if (this.previousButton instanceof HTMLButtonElement) {
        this.previousButton.disabled = this.scroller.scrollLeft <= 1;
      }

      if (this.nextButton instanceof HTMLButtonElement) {
        this.nextButton.disabled = maximumScroll <= 1 || this.scroller.scrollLeft >= maximumScroll - 1;
      }
    }

    updateActiveThumbnail(index, shouldScroll = true) {
      if (!this.buttons.length) {
        return;
      }

      const nextIndex = Math.min(Math.max(index, 0), this.buttons.length - 1);
      this.currentIndex = nextIndex;

      this.buttons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === nextIndex;
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;

        if (isActive) {
          button.setAttribute('data-active', 'true');
        } else {
          button.removeAttribute('data-active');
        }
      });

      if (shouldScroll) {
        const activeButton = this.buttons[nextIndex];

        if (!(activeButton instanceof HTMLElement) || !(this.scroller instanceof HTMLElement)) {
          return;
        }

        const scrollerBounds = this.scroller.getBoundingClientRect();
        const buttonBounds = activeButton.getBoundingClientRect();
        const maximumScroll = Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);
        let targetScroll = this.scroller.scrollLeft;

        if (buttonBounds.left < scrollerBounds.left) {
          targetScroll -= scrollerBounds.left - buttonBounds.left;
        } else if (buttonBounds.right > scrollerBounds.right) {
          targetScroll += buttonBounds.right - scrollerBounds.right;
        }

        this.scroller.scrollTo({
          left: Math.min(Math.max(targetScroll, 0), maximumScroll),
          behavior: 'smooth',
        });
      }
    }
  }

  if (!customElements.get('product-media-slideshow')) {
    customElements.define('product-media-slideshow', ProductMediaSlideshow);
  }

  if (!customElements.get('media-dots')) {
    customElements.define('media-dots', MediaDots);
  }

  if (!customElements.get('product-media-controls')) {
    customElements.define('product-media-controls', ProductMediaControls);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simply-tab-layout"] && !Shopify.designMode) return;
  try {
    class SimplyTabLayout extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      if (!this.triggers.length || this.triggers.length !== this.panels.length) return;

      this.initialized = true;
      this.triggers.forEach((trigger, index) => this.configureTab(trigger, this.panels[index], index));
      this.selectedIndex = 0;
      this.updateTabState(0);
      this.panels.forEach((panel, index) => {
        panel.hidden = index !== 0;
      });

      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => this.selectTab(index));
        trigger.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
    }

    configureTab(trigger, panel, index) {
      const tabId = `${this.dataset.tabLayoutId}-tab-${index + 1}`;
      const panelId = `${this.dataset.tabLayoutId}-panel-${index + 1}`;

      trigger.id = tabId;
      trigger.setAttribute('aria-controls', panelId);
      panel.id = panelId;
      panel.setAttribute('aria-labelledby', tabId);
    }

    async selectTab(selectedIndex) {
      if (selectedIndex === this.selectedIndex || this.isTransitioning) return;

      const previousPanel = this.panels[this.selectedIndex];
      const selectedPanel = this.panels[selectedIndex];

      this.isTransitioning = true;
      this.selectedIndex = selectedIndex;
      this.updateTabState(selectedIndex);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        previousPanel.hidden = true;
        selectedPanel.hidden = false;
        this.isTransitioning = false;
        return;
      }

      await previousPanel.animate(
        [
          { opacity: 1, transform: 'translateY(0)' },
          { opacity: 0, transform: 'translateY(-0.75rem)' },
        ],
        { duration: 250, easing: 'ease', fill: 'forwards' },
      ).finished;

      previousPanel.hidden = true;
      previousPanel.style.opacity = '';
      previousPanel.style.transform = '';
      selectedPanel.hidden = false;

      await selectedPanel.animate(
        [
          { opacity: 0, transform: 'translateY(-0.75rem)' },
          { opacity: 1, transform: 'translateY(0)' },
        ],
        { duration: 250, easing: 'ease', fill: 'both' },
      ).finished;

      selectedPanel.style.opacity = '';
      selectedPanel.style.transform = '';
      this.isTransitioning = false;
    }

    updateTabState(selectedIndex) {
      this.triggers.forEach((trigger, index) => {
        const isSelected = index === selectedIndex;

        trigger.setAttribute('aria-selected', String(isSelected));
        trigger.tabIndex = isSelected ? 0 : -1;
        trigger.toggleAttribute('data-active', isSelected);
      });
    }

    handleKeydown(event, currentIndex) {
      let nextIndex = currentIndex;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.triggers.length;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + this.triggers.length) % this.triggers.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.triggers.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.selectTab(nextIndex);
      this.triggers[nextIndex].focus();
    }
  }

  if (!customElements.get('simply-tab-layout')) {
    customElements.define('simply-tab-layout', SimplyTabLayout);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simply-variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.variantDataElement = this.querySelector('[data-variant-data]');
      this.selects = Array.from(this.querySelectorAll('.variant-option-select'));
      this.statusElement = this.querySelector('[data-variant-status]');
      this.productInformation = this.closest('product-information');
      this.hiddenVariantIdInputs = Array.from(
        this.productInformation?.querySelectorAll('[data-selected-variant-id]') || [],
      );
      this.priceElement = this.productInformation?.querySelector('[data-variant-price]') || null;
      this.compareAtPriceElement = this.productInformation?.querySelector('[data-variant-compare-at-price]') || null;
      this.productMediaSlideshow = document.getElementById(`product-media-slideshow-${this.dataset.sectionId}`);
      this.onChange = this.onChange.bind(this);

      if (!(this.variantDataElement instanceof HTMLScriptElement)) {
        return;
      }

      try {
        this.variants = JSON.parse(this.variantDataElement.textContent || '[]');
      } catch (error) {
        console.error('Failed to parse variant data', error);
        this.variants = [];
      }

      if (!this.variants.length || !this.selects.length) {
        return;
      }

      this.currentVariant =
        this.variants.find((variant) => String(variant.id) === this.dataset.initialVariantId) ||
        this.variants.find((variant) => variant.available) ||
        this.variants[0];

      if (!this.currentVariant) {
        return;
      }

      this.addEventListener('change', this.onChange);
      this.applyVariant(this.currentVariant, { updateHistory: false });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange(event) {
      const select = event.target;

      if (!(select instanceof HTMLSelectElement)) {
        return;
      }

      const selection = this.getSelectedOptions();
      const optionIndex = Number(select.dataset.optionIndex);

      let nextVariant = this.findExactVariant(selection);

      if (!nextVariant) {
        nextVariant = this.findFallbackVariant(optionIndex, select.value, selection);
      }

      if (!nextVariant) {
        return;
      }

      this.applyVariant(nextVariant);
    }

    applyVariant(variant, { updateHistory = true } = {}) {
      this.currentVariant = variant;
      this.syncSelects(variant.options);
      this.updateOptionAvailability(variant.options);
      this.updatePrice(variant);
      this.updateStatus(variant);
      this.updateHiddenVariantIds(variant);
      this.updateMedia(variant);

      if (updateHistory) {
        this.updateUrl(variant);
      }

      this.dispatchEvent(
        new CustomEvent('simply-product-information:variant-change', {
          bubbles: true,
          detail: {
            variant,
          },
        }),
      );
    }

    getSelectedOptions() {
      return this.selects.map((select) => {
        return select.value || '';
      });
    }

    findExactVariant(selection) {
      return this.variants.find((variant) => {
        return variant.options.every((optionValue, optionIndex) => optionValue === selection[optionIndex]);
      });
    }

    findFallbackVariant(changedOptionIndex, changedValue, selection) {
      return (
        this.variants.find((variant) => {
          if (variant.options[changedOptionIndex] !== changedValue) {
            return false;
          }

          return selection.every((selectedValue, optionIndex) => {
            if (!selectedValue || optionIndex === changedOptionIndex) {
              return true;
            }

            return variant.options[optionIndex] === selectedValue;
          });
        }) ||
        this.variants.find((variant) => variant.options[changedOptionIndex] === changedValue && variant.available) ||
        this.variants.find((variant) => variant.options[changedOptionIndex] === changedValue)
      );
    }

    findMatchingVariant(selection) {
      return this.variants.find((variant) => {
        return selection.every((selectedValue, optionIndex) => {
          if (!selectedValue) {
            return true;
          }

          return variant.options[optionIndex] === selectedValue;
        });
      });
    }

    syncSelects(selectedOptions) {
      this.selects.forEach((select) => {
        const optionIndex = Number(select.dataset.optionIndex);
        select.value = selectedOptions[optionIndex] || '';
      });
    }

    updateOptionAvailability(selectedOptions) {
      this.selects.forEach((select) => {
        const optionIndex = Number(select.dataset.optionIndex);

        Array.from(select.options).forEach((option) => {
          const nextSelection = [...selectedOptions];
          nextSelection[optionIndex] = option.value;
          const matchingVariant = this.findMatchingVariant(nextSelection);

          option.disabled = !matchingVariant?.available;
          option.textContent = option.dataset.optionLabel || option.value;

          if (option.disabled) {
            option.textContent = `${option.textContent} (${this.dataset.soldOutLabel || ''})`;
          }
        });
      });
    }

    updatePrice(variant) {
      if (this.priceElement) {
        this.priceElement.textContent = variant.formatted_price;
      }

      if (this.compareAtPriceElement) {
        const showCompareAtPrice = Number(variant.compare_at_price) > Number(variant.price);

        this.compareAtPriceElement.hidden = !showCompareAtPrice;
        this.compareAtPriceElement.textContent = showCompareAtPrice ? variant.formatted_compare_at_price : '';
      }
    }

    updateStatus(variant) {
      if (!(this.statusElement instanceof HTMLElement)) {
        return;
      }

      if (variant.available) {
        this.statusElement.hidden = true;
        this.statusElement.textContent = '';
        return;
      }

      this.statusElement.hidden = false;
      this.statusElement.textContent = this.dataset.soldOutLabel || this.dataset.unavailableLabel || '';
    }

    updateHiddenVariantIds(variant) {
      this.hiddenVariantIdInputs.forEach((input) => {
        if (input.value === String(variant.id)) {
          return;
        }

        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updateMedia(variant) {
      if (!(this.productMediaSlideshow instanceof HTMLElement) || !variant.featured_media_id) {
        return;
      }

      const slides = Array.from(this.productMediaSlideshow.querySelectorAll('[data-product-media-id]'));
      const nextIndex = slides.findIndex((slide) => {
        return String(slide.dataset.productMediaId) === String(variant.featured_media_id);
      });

      if (nextIndex < 0 || typeof this.productMediaSlideshow.select !== 'function') {
        return;
      }

      this.productMediaSlideshow.select(nextIndex);
    }

    updateUrl(variant) {
      if (!variant.url) {
        return;
      }

      window.history.replaceState({}, '', variant.url);
    }
  }

  if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
  }
  } catch(e) { console.error(e); }
})();

})();
